import { createSelector } from '@reduxjs/toolkit';

const selectAppointmentAndSlotsByUserEntries = (state) =>
    state.entities.calendarService.appointmentsAndSlotsByUser;

const selectAppointmentAndSlotsByUserAndDateEntries = (state) =>
    state.entities.calendarService.appointmentsAndSlotsByUserAndDate;

const selectUserEventsByUserAndDateEntries = (state) =>
    state.entities.calendarService.userEventsByUserAndDate;

export const selectUsersAppointmentsAndSlots = () =>
    createSelector(
        selectAppointmentAndSlotsByUserEntries,
        (_, id) => id,
        (appointmentsAndSlotsByUser, id) => appointmentsAndSlotsByUser[id] || []
    );

export const selectAllUserAppointmentsAndSlotsByUserAndDate = createSelector(
    selectAppointmentAndSlotsByUserAndDateEntries,
    (appointmentsAndSlotsByUserAndDate) => Object.values(appointmentsAndSlotsByUserAndDate).flat()
);

export const selectAllUserEventsByUserAndDate = createSelector(
    selectUserEventsByUserAndDateEntries,
    (userEventsByUserAndDate) => Object.values(userEventsByUserAndDate).flat()
);
